import React, { Component } from "react";

// Configs
import { endpoints } from "../../configs";
import { isLoggedIn } from "../../lib/helper";

// Components
import PageTitle from "../../components/base/PageTitle";
import ReduxTable, { ReduxColumn } from "../../components/base/ReduxTable";

export default class PartnerRequest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sortByOptions: [
        {
          value: "createdAt:DESC",
          label: "Most Recent"
        },
        {
          value: "form_name:ASC",
          label: "Name"
        }
      ]
    };
  }
  componentDidMount() {
    // Check is logged in user
    isLoggedIn();
  }

  componentDidUpdate() {
    // Check is logged in user
    isLoggedIn();
  }

  render() {
    return (
      <div>
        <PageTitle label="Partner Requests" />

        <div>
          <ReduxTable
            id="partnerRequest"
            apiURL={`${endpoints().contactFormSubmission}/list`}
            newTableHeading
            showHeader
            searchPlaceholder="Search"
            sortByOptions={this.state.sortByOptions}
            onRowClick={row =>
              this.props.history.push(`/partner-requests/details/${row.id}`)
            }
          >
            <ReduxColumn type="link" isClickable="true" field="formName">
              Form Name
            </ReduxColumn>
            <ReduxColumn field="createdAt">Submitted At</ReduxColumn>
          </ReduxTable>
        </div>
      </div>
    );
  }
}
